import type { ReactNode, FC } from 'react';
import classnames from 'classnames';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import Sticky from '@wix/da-ds/pkg/Sticky';
import { getStickyContentHeight } from '../../helpers';

import s from './StickyBar.scss';

export interface Props {
  children(isStuck: boolean): ReactNode;
}

export const StickyBar: FC<Props> = props => {
  return (
    <ErrorBoundary debugComponent="StickyBar">
      <div className={s['wrapper-placeholder']}>
        <Sticky
          className={classnames(s['sticky'], s['but-unsticky'])}
          marginTop={getStickyContentHeight()}
        >
          {isStuck => (
            <div className={classnames(s['content'], isStuck && s['stuck'])}>
              {props.children(isStuck)}
            </div>
          )}
        </Sticky>
      </div>
    </ErrorBoundary>
  );
};
StickyBar.displayName = 'StickyBar';

export default StickyBar;
